import React, { useState, createContext, useContext } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Cars from './pages/Cars';
import Admin from './pages/Admin';
import Contact from './pages/Contact';
import Toast from './components/Toast';
import translations from './translations';

export const ToastContext = React.createContext(null);
export const LangContext = createContext({ lang: 'en', t: (k) => k });

export function useLang() {
  return useContext(LangContext);
}

export default function App() {
  const [page, setPage] = useState('home');
  const [toast, setToast] = useState(null);
  const [lang, setLang] = useState('en');

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3500);
  };

  const t = (key) => translations[lang]?.[key] || translations['en'][key] || key;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <ToastContext.Provider value={showToast}>
        <Navbar page={page} setPage={setPage} />
        {page === 'home' && <Home setPage={setPage} />}
        {page === 'cars' && <Cars />}
        {page === 'contact' && <Contact />}
        {page === 'admin' && <Admin />}
        {toast && <Toast message={toast.message} type={toast.type} />}
      </ToastContext.Provider>
    </LangContext.Provider>
  );
}